import React from "react";
import { Pencil, PlusCircleFill } from "react-bootstrap-icons";
import "../../assets/css/style.css";
import { CardProps } from "./Card.type";
import DashboardToggle from "../../Components/FormTag/DashboardToggle";

const Card: React.FC<CardProps> = ({
  fields,
  data,
  header,
  getDetails,
  handleEditAction,
  handleToggleChange,
  hideEditButton=false
}) => {
  const handleGetDetails = (item: any) => {
    if (getDetails) getDetails(item);
  };

  const handleEdit = (data: any) => {
    if (handleEditAction) handleEditAction(data);
  };

  return (
    <>
      {/* Map through the data and render each item */}
      {data.map((item, index) => (
        <div
          key={index}
          className="col-lg-2 col-md-3 col-sm-6 col-xs-auto me-3 my-2 d-flex flex-column shadow grid-view-customer cursor-pointer"
        >
          <div className="d-flex justify-content-between p-2">
            {header?.map((header, index) => (
              <div
                key={index}
                className="mt-2 d-flex align-items-center text-truncate me-2"
                onClick={() => handleGetDetails(item)}
              >
                <span className="fs-15">
                  <strong>
                    {header.selector ? header.selector(item) : "N/A"}
                  </strong>
                </span>
              </div>
            ))}
            {!hideEditButton ? (
              <div
                className="cursor-pointer d-flex align-items-center text-light-grey"
                onClick={() => handleEdit(item)}
              >
                <Pencil size="16" />
              </div>
            ):(<></>)}
          </div>
          <div className="border-top" onClick={() => handleGetDetails(item)}>
            {/* Render fields dynamically based on the fields prop */}
            {fields.map((field, index) => (
              <div
                key={index}
                className="my-1 mx-2 d-flex justify-content-start"
              >
                {field.name ? (
                  <span>
                    <strong className="me-1 text-nowrap">{field.name}:</strong>{" "}
                  </span>
                ) : (
                  ""
                )}
                <>
                  <span className="text-secondary  text-truncate">
                    {field.selector ? field.selector(item) : "N/A"}
                  </span>
                </>
              </div>
            ))}
          <div className="border-top pt-2 pb-1 text-end cursor-pointer mt-auto d-flex justify-content-end">
            <DashboardToggle className="active-grid-button btn btn-info rounded-pill py-0 ps-3 pe-0" 
              defaultChecked={item.is_active === 1}
              handleToggleChange={(status: boolean | number) => handleToggleChange?.(item,status)}
            />
          </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Card;
